export const user = {
    types: {
        ADMIN: "Administrator",
        MANAGER: "Manager",
        TECHNICAL: "Technical",
    },
    labels: {
        uninformed: "Uninformed",
    },
};
